import React,{useState} from "react";
import { useGetHotels,useUpdateHotelReview } from "../../hooks/hotel.hooks";
import "@ant-design/compatible/assets/index.css";
import {Collapse,message,Button } from "antd";
import Breadcrumb from "../../components/Breadcrumb";
import HotelReviewTable from "../../components/HotelReviews/HotelReviewTable";
import HotelReviewForm from "../../components/HotelReviews/HotelReviewForm";

const HotelReview = (props) => {
  const { label,path,tableTitle,dataIndex } = props;
  const [selectedRowKeys,setSelectedRowKeys] = useState();
  const onSelectChange= (selectedRowKeys)=>setSelectedRowKeys(selectedRowKeys);
  const rowSelection = { selectedRowKeys, onChange: onSelectChange };

  const {
    isLoading: isLoadingHotelsData,
    data: hotelsGetData,
    refetch: reloadGetHotels,
  } = useGetHotels();

  const { mutate: updateReviews, isLoading: ongoingUpdate } = useUpdateHotelReview({
    onSuccess: () => {
      message.success("Hotel Successfully Updated");
      reloadGetHotels();
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const handleSubmit = async (e) =>  {
    e.dataIndex = e.dataIndex == null ? undefined : e.dataIndex ;
    const result = await updateReviews(e);
    reloadGetHotels();
  };

  const removeLinks = async () => {
    selectedRowKeys.forEach(async (id) => {
      const values = {
        _id: id,
      };
      values[dataIndex] = "";
      await updateReviews(values);
    });
    reloadGetHotels();
  };

    return (
      <>
        <div className="container_aa">
          <h3>{label}</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },

              {
                path: path,
                breadcrumbName: label,
              },
            ]}
          />
          
        </div>
        <div className="container_ab">
          <div className="container_style_2">
            <Collapse defaultActiveKey={["1"]} expandIconPosition="end">
              <Collapse.Panel
                header={`${label} - Hotel Mapping `}
                key="1"
                arrow="right"
              >
                <div className="is_form_1">
                  <HotelReviewForm
                    title={tableTitle}
                    dataIndex={dataIndex}
                    onSubmitData={handleSubmit}
                    hotelGetData={hotelsGetData}
                  />
                </div>
              </Collapse.Panel>
            </Collapse>
            <div style={{ marginBottom: 20 }}></div>
            <Collapse defaultActiveKey={["1"]} expandIconPosition="end">
              <Collapse.Panel header={`${label} - Hotel Mapping `} key="1">
                <div className="item_1">
                  <div className="item_1_a">
                    <div className="is_table_1">
                      <HotelReviewTable 
                        rowSelection={rowSelection}                       
                        label={tableTitle}
                        parameter={dataIndex}
                        data={hotelsGetData}
                      />
                    </div>
                  </div>
                </div>
                <div className="item_1_b">
                  <Button
                    disabled={!selectedRowKeys?.length>0}
                    onClick={removeLinks}
                    type="primary"
                  >
                    Delete
                  </Button>
                </div>
              </Collapse.Panel>
            </Collapse>
            
            </div>
        
      </div>
    </>
  );
};

export default HotelReview;
